import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'
const InitializeGoogleAnalytics = () => {
  ReactGA.initialize('G-NNV98SHMD3')
  ReactGA4.initialize('G-NNV98SHMD3')

  console.log('GA INITIALIZED')
}

const trackAnalyticsEvent = (
  category: string,
  action: string,
  label: string
) => {
  console.log('GA event:', category, ':', action, ':', label)
  ReactGA.event({
    category: category,
    action: action,
    label: label
  })
  ReactGA4.event({
    category: category,
    action: action,
    label: label
  })
}

export default InitializeGoogleAnalytics
export { InitializeGoogleAnalytics, trackAnalyticsEvent }
